import React from 'react';

import './styles.scss';

const VisuallyHidden = ({ children }) => {
  return <div className="visually-hidden">{children}</div>;
};

export default VisuallyHidden;
